import React from "react";
import PageWrapper from "./subAdmin.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import SubAdminTable from "../../components/subAdmin/SubAdminTable";

const SubAdmin = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.admin"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.admin"
          }
        ]}
      />
      <div className="user-tbl">
        <SubAdminTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.permissionReducer
  };
};

export default connect(mapStateToProps, null)(SubAdmin);
